import React from 'react'
import ErrorBoundary from '../../../components/ErrorBoundary'
import ReportsPage from "../../../components/settings/reports/ReportsPage"

const ReportsPageWithBoundary = (props) => (
    <ErrorBoundary
        componentName="ReportsPage"
        showReload
        logToBackend
        title="Erro em Relatórios"
        message="Ocorreu um erro ao carregar os relatórios. Tente recarregar."
    >
        <ReportsPage {...props} />
    </ErrorBoundary>
)

export default ReportsPageWithBoundary